import React from "react";
import { HeartIcon, PlusIcon, ShareIcon, ZoomInIcon } from "../Icon/Icon";

const ActionButtonsBar = ({ onZoomClick, onSkipForward, onSkipBackward }) => (
  <div className="flex items-center justify-between bg-[#08080a] px-4 py-4 sm:px-6 md:px-6 rounded-b-xs">
    {/* Left action buttons */}
    <div className="flex items-center space-x-4 sm:space-x-6">
      <button
        title="Yêu thích"
        className="flex items-center space-x-2.5 text-white hover:text-yellow-400 transition"
      >
        <HeartIcon className="h-3 w-3 lg:w-4 lg:h-4 " />
        <span className="text-[16px] hidden sm:inline">Yêu thích</span>
      </button>
      <button
        title="Thêm vào danh sách"
        className="flex items-center space-x-2.5 text-white hover:text-yellow-400 transition"
      >
        <PlusIcon className="h-3 w-3 lg:w-4 lg:h-4" />
        <span className="text-[16px] hidden sm:inline">Thêm vào</span>
      </button>
      <button
        title="Chia sẻ"
        className="flex items-center space-x-2.5 text-white hover:text-yellow-400 transition"
      >
        <ShareIcon className="h-3 w-3 lg:w-4 lg:h-4" />
        <span className="text-[16px] hidden sm:inline">Chia sẻ</span>
      </button>
    </div>
    {/* 
    <div className="flex items-center space-x-4 sm:space-x-6">

      <button
        title="Phóng to"
        className="flex items-center space-x-1.5 text-white hover:text-green-500 transition"
        onClick={onZoomClick}
      >
        <ZoomInIcon className="h-3 w-3 lg:w-4 lg:h-4" />
        <span className="text-[16px] hidden sm:inline">Phóng to</span>
      </button>
    </div> */}
  </div>
);

export default ActionButtonsBar;
